// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"666c1580","453":"515c2986","455":"68652ab1","977":"560d9717"}[chunkId] + ".chunk.js";
};